import CurriculumGoalsIcon from '@UI/curriculumGoalsIcon/CurriculumGoalsIcon';
import { DurationArrow, HoveredPopover } from '@UI/index';
import IconCurrCalendar from '@assets/img/icon_curr_calendar.svg?react';
import IconPaperClip from '@assets/img/icon_paperclip.svg';
import { useTypedSelector } from '@hooks/typedHooks';
import { selectIsActivityPlanReadOnly } from '@store/calendar/calendarSelectors';
import type { ActivityGroup } from '@store/calendar/calendarTypes';
import AttachmentsPopover from '../popovers/AttachmentsPopover';

import './activity.scss';

interface ActivityProps {
  activity: ActivityGroup;
  onSelectActivity?: (activity: ActivityGroup) => void;
  onAddActivity?: (activity: ActivityGroup) => void;
  onModifyActivity?: (activity: ActivityGroup) => void;
}

const Activity = ({
  activity,
  onSelectActivity,
  onAddActivity,
  onModifyActivity,
}: ActivityProps) => {
  const isEmpty = !!activity.empty;
  const isSelection = useTypedSelector((state) => state.calendar.selectionMode);
  const readOnly = useTypedSelector(selectIsActivityPlanReadOnly);

  const onClickActivityHandler = () => {
    if (readOnly || isSelection) return;
    if (activity.empty) onAddActivity?.(activity);
    else onModifyActivity?.(activity);
  };

  const classNames = [
    'activity',
    isEmpty && 'empty',
    readOnly && 'read-only',
    isSelection && 'selection',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <article className={classNames} onClick={onClickActivityHandler}>
      <header>
        {isEmpty || activity.goals.length === 0 ? (
          <IconCurrCalendar width={30} className="icon-curr-calendar" />
        ) : (
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          <CurriculumGoalsIcon goals={activity.goals as any} />
        )}

        <div className="class-info">
          <span>{activity.$$classesName}</span>
        </div>
        <div
          className="title"
          title={activity.title ?? undefined}
          style={activity.color ? { color: activity.color.text } : undefined}
        >
          {activity.title}
        </div>
      </header>

      <DurationArrow state={activity.arrowState} color={activity.color} />

      {/* biome-ignore lint/security/noDangerouslySetInnerHtml: HTML content from API needs to be rendered */}
      <main className="description" dangerouslySetInnerHTML={{ __html: activity.description }} />

      {isSelection && !isEmpty && (
        <div className="selector-button" onClick={() => onSelectActivity?.(activity)}>
          overnemen
        </div>
      )}

      <footer>
        {activity.attachments?.length > 0 && (
          <HoveredPopover
            disabled={false}
            compile={false}
            delay={500}
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            content={<AttachmentsPopover attachments={activity.attachments as any} />}
          >
            <div className="att-button">
              <img src={IconPaperClip} width={20} alt="" />
            </div>
          </HoveredPopover>
        )}
      </footer>
    </article>
  );
};

export default Activity;
